import React from "react";
import styles from './Main.module.scss';

interface IMainProps {
  children?: any;
}

const Main = (props: IMainProps) => {
  return (
    <div className={`${styles.mainControlContainer} main`}>
      {props.children}
    </div>
  );
};

Main.defaultProps = {};

export default React.memo(Main);
